import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Input,
  SwitchIOS,
} from "../../../../components";
import axios from "axios";
import { API_GO } from "../../../../helpers";
import useGlobalParams from "../../../../hooks/useGlobalParam";

export default function EditWorkflow() {
  const navigate = useNavigate();
  const { id } = useParams();
  const globalParam = useGlobalParams();
  const [formData, setFormData] = useState({
    entity_name: "",
    workflows: "",
    status: "active",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  React.useEffect(() => {
    if (id) {
      fetchWorkflowData();
    }
  }, [id]);

  const fetchWorkflowData = async () => {
    try {
      const response = await axios.get(
        `${API_GO}/workflows/${btoa(id)}`
      );
      setFormData(response.data.data);
    } catch (error) {
      console.error(error);
      setError("Failed to fetch workflow data");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStatusChange = (checked) => {
    setFormData((prev) => ({
      ...prev,
      status: checked ? "active" : "inactive",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await axios.put(
        `${API_GO}/workflows/${btoa(id)}`,
        formData
      );
      navigate("/master/workflow");
    } catch (error) {
      console.error(error);
      setError("Failed to update workflow");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Edit Workflow</h1>
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Entity Name</label>
          <Input
            name="entity_name"
            value={formData.entity_name}
            onChange={handleChange}
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Workflows</label>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Status</label>
          <div className="flex items-center space-x-2">
            <SwitchIOS
              checked={formData.status === "active"}
              onChange={handleStatusChange}
            />
            <span>{formData.status === "active" ? "Active" : "Inactive"}</span>
          </div>
        </div>

        <div className="flex justify-end space-x-2">
          <Button
            variant="outline"
            onClick={() => navigate("/master/workflow")}
          >
            Cancel
          </Button>
          <Button type="submit" loading={loading}>
            Save Changes
          </Button>
        </div>
      </form>
    </div>
  );
}
